export default function () {
  $('[data-dropdown][data-close-on-click-inside="true"] a').on('click', (e) => {
    $(e.currentTarget).closest('[data-dropdown]').foundation('close');
  });
}
